import type { MultiLang } from '../../../config';
import { type ItemSimulatorSubType, ItemSimulatorSubTypes } from '../../lib/ItemUtil';

interface SimulatorTypeProps {
    lang: MultiLang;
    type: ItemSimulatorSubType;
}

const SimulatorType = (props: SimulatorTypeProps) => {
    const { type } = props;
    const subtype = ItemSimulatorSubTypes.find((value) => {
        return value.type === type;
    });
    if (typeof subtype === 'undefined') {
        return null;
    }
    return <span>{subtype.label}</span>;
};

const SimulatorUtil = {
    SimulatorType,
};

export default SimulatorUtil;
